export const Base64Url = {
    encode: (str) => btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, ''),
    decode: (b64) => {
        b64 = (b64 + '===').slice(0, b64.length + (4 - b64.length % 4) % 4);
        return atob(b64.replace(/-/g, '+').replace(/_/g, '/'));
    }
}
